import { render, staticRenderFns } from "./Option.vue?vue&type=template&id=027b8466&"
import script from "./Option.vue?vue&type=script&lang=js&"
export * from "./Option.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports